'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FLINT } from 'HubStyleTokens/colors';
import { getFullUrl } from 'hubspot-url-utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITile from 'UIComponents/tile/UITile';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import UICloseButton from 'UIComponents/button/UICloseButton';
import H1 from 'UIComponents/elements/headings/H1';
import H5 from 'UIComponents/elements/headings/H5';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import blobImageUrl from 'bender-url!marketplace-assets-base/img/how-to-choose-theme-blob.png';
import { useResponsiveProps } from 'ecosystem-marketplace-core/hooks/useResponsiveProps';
import * as ScreenSizes from 'ecosystem-marketplace-core/constants/layout/ScreenSizes';

const getKnowledgeArticleLink = () => `${getFullUrl('knowledge')}/website-pages/use-themes`;

const BlobUIFlex = styled(UIFlex).withConfig({
  displayName: "WelcomeBanner__BlobUIFlex",
  componentId: "sc-2r9mxn-0"
})(["padding:40px;background-position:right;background-image:url(", ");background-repeat:no-repeat;background-size:cover;"], blobImageUrl);

const getBannerHidden = () => {
  try {
    return localStorage.getItem('marketplace-assets:welcome-banner-hidden') === 'true';
  } catch (err) {
    console.error(err);
    return false;
  }
};

const WelcomeBanner = ({
  onTrackInteraction
}) => {
  const [bannerHidden, setBannerHidden] = useState(getBannerHidden());
  const {
    isMobileView
  } = useResponsiveProps({
    isMobileView: {
      [ScreenSizes.XS]: true,
      [ScreenSizes.SM]: false
    }
  });
  const trackInteraction = useCallback(action => {
    onTrackInteraction(action, {
      section: 'section::welcome-banner::static'
    });
  }, [onTrackInteraction]);
  const handleSetBannerHidden = useCallback(() => {
    setBannerHidden(true);

    try {
      localStorage.setItem('marketplace-assets:welcome-banner-hidden', true);
    } catch (err) {
      console.error(err);
    }
  }, [setBannerHidden]);

  if (bannerHidden) {
    return null;
  }

  return /*#__PURE__*/_jsx(UITile, {
    children: /*#__PURE__*/_jsxs(UIFlex, {
      direction: isMobileView ? 'column' : 'row',
      align: "center",
      children: [/*#__PURE__*/_jsx(UICloseButton, {
        color: FLINT,
        onClick: () => {
          handleSetBannerHidden();
          trackInteraction('click close welcome banner');
        }
      }), /*#__PURE__*/_jsxs(BlobUIFlex, {
        direction: "column",
        style: {
          width: !isMobileView && '55%'
        },
        children: [/*#__PURE__*/_jsx(H1, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.storefront.welcomeBanner.title"
          })
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          className: "m-bottom-3",
          message: "marketplace-assets-ui.storefront.welcomeBanner.subtitle",
          style: {
            fontSize: '16px'
          }
        }), /*#__PURE__*/_jsx(UILink, {
          className: "m-bottom-5",
          href: getKnowledgeArticleLink(),
          external: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.storefront.welcomeBanner.knowledgeArticleLink"
          })
        }), /*#__PURE__*/_jsx(UIRouterButton, {
          onClick: () => {
            trackInteraction('click explore all themes');
          },
          to: "/themes",
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.storefront.welcomeBanner.buttonText"
          })
        })]
      }), /*#__PURE__*/_jsxs(UIFlex, {
        className: "p-all-8 p-right-15",
        direction: "column",
        style: {
          width: !isMobileView && '45%'
        },
        children: [/*#__PURE__*/_jsxs(UIFlex, {
          className: "m-bottom-6",
          direction: "row",
          children: [/*#__PURE__*/_jsx("span", {
            className: "is--heading-1",
            children: "1"
          }), /*#__PURE__*/_jsxs(UIFlex, {
            className: "p-left-3 p-top-1",
            direction: "column",
            children: [/*#__PURE__*/_jsx(H5, {
              className: "m-bottom-1",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-assets-ui.storefront.welcomeBanner.firstPointTitle"
              })
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.storefront.welcomeBanner.firstPointSubtitle"
            })]
          })]
        }), /*#__PURE__*/_jsxs(UIFlex, {
          direction: "row",
          children: [/*#__PURE__*/_jsx("span", {
            className: "is--heading-1",
            children: "2"
          }), /*#__PURE__*/_jsxs(UIFlex, {
            className: "p-left-3 p-top-1",
            direction: "column",
            children: [/*#__PURE__*/_jsx(H5, {
              className: "m-bottom-1",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-assets-ui.storefront.welcomeBanner.secondPointTitle"
              })
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.storefront.welcomeBanner.secondPointSubtitle"
            })]
          })]
        })]
      })]
    })
  });
};

WelcomeBanner.propTypes = {
  onTrackInteraction: PropTypes.func.isRequired
};
export default WelcomeBanner;